import { adminPaths } from 'routes/constants/adminPaths';
import { isAdminAuthenticated } from 'routes/guards/session';

import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { capturePostLoginRedirectFromLocation } from '@/services/auth/postLoginRedirectStorage';

/**
 * Admin private routes. On unauthenticated access, capture a same-app deep link
 * (e.g. email CTA) into Redux + localStorage so login/OTP can restore it.
 * Session expiry / logout still clears storage via redirectToLogin (SCRUM-2096).
 */
const AdminPrivateRoute = () => {
  const location = useLocation();

  if (!isAdminAuthenticated()) {
    capturePostLoginRedirectFromLocation({
      pathname: location.pathname,
      search: location.search,
      hash: location.hash,
    });
    return <Navigate to={adminPaths.signIn} replace />;
  }

  return <Outlet />;
};

export default AdminPrivateRoute;
